/* ============================================================
   ORA PERFORMANCE v3 — standalone runtime
   1. FR/EN content (FR lives in the HTML, EN below; shares 'ora-lang' with the site)
   2. Drop engine (state-driven bar, chips, CTAs, product grid, countdown, sticky CTA)
   3. Visit attribution (UTM + source_event, session only) + tracking (dataLayer + Plausible)
   4. Lead forms (validation, anti-spam, submission)
   5. Subtle reveal on scroll
   ============================================================ */
(function () {
  'use strict';

  var CFG = {
    endpoint: '/api/lead.php',
    plausible: { enabled: true, src: 'https://plausible.io/js/pa-prfXxww4yxYTqeVaJYrd-.js' }
  };
  var BODY = document.body;
  var PAGE = BODY.getAttribute('data-page') || '';
  var DROP = window.ORA_DROP || null;
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var LANG = 'fr';

  /* ================= 1. ENGLISH ================= */
  var EN = {
    'a11y.skip': 'Skip to content',  'nav.teams': 'Teams &amp; clubs', 'nf.home': 'Home', 'nf2.p': 'This page doesn’t exist or has moved.', 'nf.title': 'Page not found',
     'ft.legalK': 'Legal', 'ft.legal': 'Legal notice', 'ft.privacy': 'Privacy', 'ft.cgv': 'Terms of sale',
    'cx.opt': 'Motorsport / Racing Team',
      'cg.k': 'Terms of sale', 'cg.updated': 'Version in force: 16 October 2026',
    'pk.note': 'Drop 04 = 4 units for one person · Drop 08 = 4 units each for two people',
    'hx.tag': 'Pizza · Pasta',
     'dr.labelAria': 'Drop 001 Reload label',
    'lb.dough': 'Dough', 'lb.carbs': 'Carbs', 'lb.protein': 'Protein', 'lb.energy': 'Energy', 'lb.lot': 'Batch',
    'lb.tba': 'TBA', 'lb.tbaLot': '· TBA',
    'dr.specDough': 'dough ball', 'dr.specCarbs': 'carbs', 'dr.baseNote': 'Dough-base values, before toppings.',
    'dr.specPasta': 'fresh pasta',  'dr.pastaNote': 'Pasta-only values, before sauce and toppings.',
    'lb.footPizza': '<b>14C Protocol</b><br>Contains gluten (einkorn)<br>Final topped values at opening',
      'dr.fPasta': 'Pasta',
    'lb.p': 'Format, dough, macros, lot: it’s all on the label. Clear numbers, right on the product.',
    'dr.areas': 'Delivery areas and schedule announced with the first Drop.',
     'dr.wP': 'Sign up: we let you know as soon as Drop 001 opens, so you can order among the first. No commitment.',
    'cu.cta': 'Let’s talk about your project →',
    'lg.k': 'Legal', 'lg.updated': 'Updated: October 3, 2026',
    'f.org': 'Organization / team', 'f.offer': 'Project type', 'f.optComp': 'Competition / Event', 'f.optCamp': 'Training camp / Preparation', 'f.optClub': 'Club / Team', 'f.optFed': 'Federation / League / Organization', 'f.optOther': 'Other',
    'f.discipline': 'Discipline / sports environment', 'f.disciplinePh': 'e.g. MMA, cycling, football, endurance, motorsport…', 'f.choose': 'Choose…',
    'f.athletes': 'Number of athletes', 'f.period': 'Period / dates', 'f.optional': '(optional)', 'f.periodPh': 'e.g. November 2026',
    'f.location': 'City / country', 'f.staffLegend': 'Performance staff contact', 'f.name': 'Name', 'f.role': 'Role',
    'f.rolePh': 'Strength coach, nutritionist, coach…', 'f.email': 'Email', 'f.phone': 'Phone', 'f.message': 'Message',
    'f.noHealth': 'Please don’t include any medical or health information.',
    'f.noticeB2B': 'Your details are used only to respond to your request. <a href="/pages/mentions-legales#privacy">Privacy policy</a>.',
    'f.firstName': 'First and last name', 'f.city': 'City', 'f.postal': 'Postal code', 'f.gym': 'Sports organization',
    'f.consentWaitlist': 'I’d like an email when the next ORA Drop opens.',
    'f.consentNews': 'I also agree to receive occasional ORA Performance news. (optional)',
    'f.noticeConsumer': 'Your details (name, email, city, postcode) are only used to tell you when ORA Drops open and, if you agree, to send you our news. You can unsubscribe at any time via the link in every email. <a href="/pages/mentions-legales#privacy">Privacy policy</a>.',
    'f.joinList': 'Join early access',
    'nx.performance': 'How do we do it?', 'nx.system': 'Tested where?', 'nx.fightweek': 'Who is behind it?', 'nx.origin': 'Time to act', 'nx.teams': 'See the Drop', 'nx.contact': 'Discover ORA', 'nv2.step': 'Next step', 'cta.start': 'Start',
    'fw2.d1': 'Reload', 'fw2.d1s': 'Different needs', 'fw2.d2': 'Recover', 'fw2.d2s': 'An answer tailored to each athlete',
    'f.okH': 'It’s in the dough! 🍕',
    'f.okP': 'Your message is in. We’ll let it rest for a moment and get back to you before the proofing time is up!',
    'f.structure': 'Facility name', 'f.country': 'Country', 'f.members': 'Number of members',
    'f.m1': 'Under 100', 'f.m3': '300 – 1,000', 'f.m4': 'Over 1,000',
    'f.locations': 'Number of locations', 'f.contactName': 'Contact name', 'f.becomeDP': 'Become a Drop Point',
    /* v3 chapters (2026-10-06) */
    'pr2.k': 'As seen in', 'sh.teams': 'Talk about your project', 'sh.dp': 'Become a Drop Point', 'sh.acces': 'Join early access',
    'nv2.close': 'Close', 'nv2.next': 'Next chapter', 'nv2.chapters': 'Chapters',
    'nv2.gDrop': 'The product, its macros, ordering.', 'nv2.gPerf': 'Why ORA exists, how it is made, where it comes from.', 'nv2.gTeams': 'For performance staff, clubs and organizations.',
    'hm2.s2': 'You have the targets. We have the formula.', 'hm2.c2': 'Pasta', 'hm2.c2b': 'Fresh &amp; dry',
    'dr2.fq1': 'When does Drop 001 open?', 'dr2.fa1': "On 10 January 2027 at 10:00 (Paris time). Orders open automatically at that time, within the limit of the quantities produced. Join the waiting list to be notified.",
    'dr2.fq7': 'A new Drop every week?', 'dr2.fa7': 'Yes. Every week, a new Drop and new flavours, made in limited runs.',
    'dr2.fq2': 'How is my order delivered?', 'dr2.fa2': "Temperature-controlled, across mainland France, by Chronofresh, within 24 to 48 h of shipping. Packs are prepared in batches and shipped after the ordering window; the shipping date is shown before you confirm.",
    'dr2.fq3': 'Can I pick up my order at a club?', 'dr2.fa3': "Yes, when Drop Points are available: choose your partner club in the cart. The place, date and pickup hours are sent to you before your order is ready.",
    'dr2.fq4': 'What is in a pack?', 'dr2.fa4': "1× Drop, 4× Drop, 8× Drop or 12× Drop: 1, 4, 8 or 12 Performance Units, Drop 001 pizza and pasta. The detailed line-up is announced at opening.",
    'dr2.fq5': 'Are there allergens?', 'dr2.fa5': "Our dough is made with einkorn: it contains gluten. The full allergen list is on each product page and on the label.",
    'dr2.fq6': 'Can I cancel my order?', 'dr2.fa6': "Fresh products are not covered by the 14-day withdrawal right. Email us as soon as possible at info@ora1929.com: if preparation has not started, we can accept the cancellation.",
    "p2.h1": "<span>Built around</span><span><em>the reload.</em></span>",
    "p2.h2": "<span>Real food.</span><span><em>Known macros.</em></span>",
    "p2.h3": "<span>Not a formula.</span><span><em>A system.</em></span>",
    "fw2.h1": "<span>Born in</span><span><em>fight week.</em></span>",
    "fw2.h3": "<span>Built to</span><span><em>go beyond.</em></span>",
    "fw2.h4": "<span>Staff-led.</span><span><em>ORA-built.</em></span>",
    "sy2.h1": "<span>The difference</span><span><em>is in the dough.</em></span>",
    "sy2.h2": "<span>Flour.</span><span>Fermentation.</span><span><em>Time.</em></span>",
    "sy2.h3": "<span>Built for</span><span><em>the Elite.</em></span>",
    "tm2.h1": "<span>You set</span><span>the targets.</span><span><em>We build</em></span><span><em>the food.</em></span>",
    "tm2.h4": "<span>Work with</span><span><em>ORA.</em></span>",
    "or2.h1": "<span>Master pastaio.</span><span><em>International</em></span><span><em>pizza champion.</em></span>",
    "or2.h4": "<span>From competition</span><span><em>to performance food.</em></span>",
    "ct2.h1": "<span>Let’s</span><span><em>talk.</em></span>",
    "dr2.h3": "<span>Known</span><span><em>macros.</em></span>",
    "dr2.h5": "<span>Shop</span><span><em>Drop 001.</em></span>",
    "dr2.hf": "<span>Good</span><span><em>to know.</em></span>",
    "hm2.h2": "<span>Real food.</span><span><em>Built around performance.</em></span>",
    "nf2.h1": "<span>Page</span><span><em>not found.</em></span>",
    "p2.s2": "Pizza &amp; pasta engineered around performance targets.",
    "p2.s3": "Built to adapt.",
    "fw2.s1": "Built where nutrition has to perform.",
    "fw2.s2": "Different moments. Different requirements.",
    "fw2.s4": "You set the targets. We build the food.",
    "dr2.s1": "Real pizza. Known macros.",
    "ey.origin": "Origin",
    "ey.teams": "Teams &amp; Athletes",
    "ey.system": "The System",
    "ey.workflow": "Workflow",
    "ey.404": "Page not found",
    "nvc.drop": "Limited releases",
    "nvc.perf": "Built around the reload",
    "nvc.fw": "Born in competition",
    "nvc.sys": "Flour. Fermentation. Precision.",
    "nvc.teams": "Staff-defined targets",
    "nvc.origin": "From competition to performance food",
    "nvc.contact": "Let’s talk",
    "nvt.sys": "The System",
    "nvt.teams": "Teams &amp; Athletes",
    "nvt.origin": "Origin",
    "nvt.teamsTop": "Teams",
    "nvl.drop": "Real pizza. Known macros.",
    "nvl.label": "The label",
    "nvt.shop": "Shop the drop",
    "nvl.shop": "Packs &amp; waiting list",
    "nvl.dp": "Partner gyms &amp; clubs",
    "nvt.workflow": "Workflow",
    "nvl.workflow": "Targets · Build · Validate · Produce",
    "nvl.formats": "Pizza · Fresh pasta · Dry pasta",
    "nvt.work": "Work with ORA",
    "nvl.work": "Talk about your project",
    "ft.tag": "Pizza · Pasta · Performance Nutrition<br>Born in fight week.",
    "cta.sys": "Discover the system",
    "cta.work": "Work with ORA",
    "cta.shop1": "Reserve my Drop",
    "cta.shop": "Shop the drop",
    "cta.teams": "For teams",
    "fw2.t1": "Before.",
    "fw2.t2": "Reload.",
    "fw2.t3": "Recover.",
    "tm2.n1": "Targets",
    "tm2.n2": "Build",
    "tm2.n3": "Validate",
    "tm2.n4": "Produce",
    "or2.cr1": "California Grand Champion 2026",
    "or2.cr3": "World Top 08",
    "or2.cr4": "Master Pastaio",
    "sy2.e1": "Flour",
    "sy2.e3": "Time",
    "cta.fwteams": "For teams",
    "lk.teams": "Teams",
    "lk.sys": "The System",
    "lk.origin": "Origin",
    'p2.p1': 'While sport swore only by protein,<br><span class="nw">ORA&nbsp;1929 puts carbohydrate reloading back at the heart of performance.</span><br>Our challenge? Maximum efficiency and perfect digestion,<br>with no compromise on flavor.', 'p2.p1b': 'California champion, finalist of the French championship, our dough is heading for the World&nbsp;Championship.', 'p2.claim': 'Aligning performance <em>&amp; haute cuisine.</em>', 'p2.s1': 'Approved by the toughest judges.', 'hx.claim': '<span class="hx__l1">The first competition pizza built for carbohydrate reloading.</span> <em>Without sacrificing taste.</em>', 'hx.proof': 'Champion in California and finalist of the French Championship, on the road to the 2027&nbsp;World Championships.',
    'p2.c2': 'Pasta', 'p2.pillars': '<li>Carbs</li><li>Digestibility</li><li>Palatability</li><li>Modularity</li>',
    'p2.p3': 'Targets are set by the athlete, the coach, the nutritionist or the performance staff, ORA builds the food around them.',
    'fw2.disc': '<li>MMA</li><li>Boxing</li><li>Trail</li><li>Hyrox</li><li>CrossFit</li><li>Cycling</li><li>Soccer</li><li>Motorsport</li>',
    'fw2.p2': 'Each phase has its own targets.', 'fw2.p3': 'Combat sports were our first proving ground — not our limit.',
    'fw2.c2': 'Motorsport', 'fw2.multi': '<li>Combat</li><li>Endurance</li><li>Strength &amp; conditioning</li><li>Motorsport</li>',
    'sy2.s1': 'The protocol is the platform.<br>Pizza and pasta are the formats.',
    'sy2.t1': 'Einkorn', 'sy2.p1': 'Triticum monococcum. The grain is the starting point — not the pitch.',
    'sy2.t2': 'Wild sourdough', 'sy2.p2': 'Lactic bacteria and wild yeasts transform the dough: structure, acidity, taste.',
    'sy2.t3': 'Cold maturation', 'sy2.p3': 'Several days, pH-guided.<br>Not faster: more controlled.',
    'sy2.note': 'Contains gluten (einkorn). Fermentation and formulation parameters remain proprietary. This content describes a production method: it is neither medical advice nor a health claim.',
    'sy2.s3': 'Every format is calibrated to the targets set by the team or the athlete.',
    'sy2.k1': 'Weight', 'sy2.v1': 'Custom', 'sy2.k2': 'Carbs', 'sy2.v2': 'Custom', 'sy2.k3': 'Protein', 'sy2.v3': 'Custom',
    'sy2.v4': 'Custom', 'sy2.v5': 'Custom', 'sy2.k6': 'Traceability', 'sy2.v6': 'Guaranteed',
    'sy2.l1': 'Work with ORA', 'sy2.l2': 'Drop 001 values',
    'tm2.s1': 'For performance staff, coaches, nutritionists, clubs and organizations.',
    'tm2.w1': 'The staff defines the nutritional targets.', 'tm2.w2': 'ORA engineers the food format around them.',
    'tm2.w3': 'The staff validates every specification.', 'tm2.w4': 'ORA produces, portions, labels and delivers.',
    'tm2.note': 'ORA provides no nutritional or medical prescription. Labeled portions, traceable by batch; shipped or produced on site.',
    'tm2.f1': '26 cm format', 'tm2.f2': "Fresh pasta", 'tm2.f3': "Dry pasta",
    'tm2.offers': '<li>Competition</li><li>Training camp</li><li>Organizations</li>',
    'tm2.p3': 'Every project is built to measure: an event, a weigh-in, a training block, a season.',
    'tm2.l1': 'Why ORA', 'tm2.l2': 'How', 'tm2.l3': 'Where ORA comes from', 'tm2.c1': 'On-site production',
    'tm2.p4': 'For staff, athletes, clubs and organizations.<br>Every request gets a personal reply.',
    'or2.p1': 'Founder of ORA 1929.', 'or2.k2': 'Credentials',
    'or2.c1': 'REAL California Pizza Challenge · Non-Traditional. First French title-holder in the category.',
    'or2.c2': 'Qualified for the 2027 World Pizza Championship in Parma.', 'or2.c3': 'Best Cheese Slice · World Pizza Challenge.',
    'or2.c4': 'Fresh pasta · ORA 1929.',
    'or2.p3': 'Hitting the targets is not enough: the athlete still has to want to eat. Taste, texture and digestibility are part of every format.',
    'or2.c5': 'The creation', 'or2.c6': 'The craft', 'or2.c7': 'French Championships 2026', 'or2.c8': 'French Pizzeria Association', 'or2.p5': 'From my grandfather’s first dough ball to my father’s wood fire, I picked up the family torch to take our craft to the highest level of competition.', 'or2.c10': 'Pictured: my grandfather and me.',
    'or2.p4': 'ORA 1929 is our culinary house: pizza, fresh pasta, sourdough, fermentation. ORA Performance turns that craft into formats built around performance.',
    'ct2.l1': 'Teams, clubs &amp; organizations', 'ct2.l2': 'Drop 001 — waiting list', 'ct2.l3': 'Gyms &amp; clubs',
    'ct2.s2': 'Become an ORA Drop pickup point.', 'ct2.p2': 'Join our selective network of partner clubs and give your members privileged access.',
    'dr2.g1': 'The pizza', 'dr2.g2': 'The dough', 'dr2.g3': 'The bake', 'dr2.g4': 'The packaging', 'dr2.mood': 'Mood images.',
    'dr2.k4': 'Essentials', 'dr2.e1': 'Pre-order', 'dr2.e1d': 'During the Drop window.', 'dr2.e2': 'Every week', 'dr2.e2d': 'A new Drop, new flavours. Limited runs.',
    'dr2.e3': 'Cold delivery', 'dr2.e3d': 'Across France, temperature-controlled.', 'dr2.e4': 'Contains gluten', 'dr2.e4d': '',
    /* B2B first (2026-10-16): new / updated EN texts — last key wins */
    'nvt.teamsTop': 'Clubs &amp; Organisations',
    'nvt.teams': 'Clubs &amp; Organisations',
    'nvc.teams': 'From brief to delivery',
    'nvt.offers': 'Offers',
    'nvl.offers': 'Fight Week · Training camp · Event',
    'nvl.workflow': 'Brief · Formulation · Production · Delivery',
    'nvt.science': 'The science',
    'nvc.fw': 'Tested in competition',
    'nvc.dough': 'Fermented by ORA, finished by you',
    'nvt.notify': 'Get notified',
    'nvl.notify': 'Waiting list',
    'nvt.about': 'About',
    'nvc.contact': 'Let’s talk about your project',
    'nvl.dp': 'Order online, pick up at your club',
    'nv2.gTeams': 'Supplier to clubs, teams, staffs and organisations.',
    'nv2.gSys': 'How ORA builds the food.',
    'nv2.gDrop': 'Limited releases, born in competition.',
    'nv2.gDough': 'The ORA dough ball, finished at home.',
    'nv2.gAbout': 'Where ORA comes from, the proof in competition.',
    'hx.tag': 'Performance food supplier',
    'hx.claim': '<span class="hx__l1">ORA designs, produces and supplies performance food formats for clubs, teams and staffs.</span> <em>You set the targets. We build the food.</em>',
    'hx.proof': 'Born in fight week, proven in competition: champion in California, finalist of the French Championship.',
    'cta.work': 'Work with ORA',
    'ey.teams': 'Clubs &amp; Organisations',
    'tm2.h1': '<span>From brief</span><span><em>to delivery.</em></span>',
    'tm2.s1': 'The staff sets the targets. ORA formulates, produces and delivers the formats: pizza, fresh and dry pasta.',
    'tm2.n1': 'Brief',
    'tm2.n2': 'Formulation',
    'tm2.n3': 'Production',
    'tm2.n4': 'Delivery',
    'tm2.w1': 'Carbs, protein, fat, fibre, sodium, portions, constraints, frequency, context.',
    'tm2.w2': 'ORA formulates the format around the targets. The staff validates.',
    'tm2.w3': 'ORA produces, portions, packs and labels.',
    'tm2.w4': 'ORA delivers, at the pace of the club or the event.',
    'ey.offers': 'Offers',
    'tm2.on3': 'Event',
    'tm2.ow1': 'D-7 to D+1. Reload around the weigh-in and the fight. Coordinated delivery.',
    'tm2.ow2': 'Monthly programme, regular delivery, adjusted by the staff.',
    'tm2.ow3': 'Competitions, organisations, activations, one-off needs.',
    'tm2.l1': 'How',
    'tm2.l2': 'The proof',
    'tm2.l3': 'The science',
    'tm2.p4': 'Clubs, teams, staffs and organisations: targets, volumes, frequency.<br>Every request gets a personal reply.',
    'fw2.s1': 'The ORA system was developed in competition, where nutrition has to perform.',
    'fw2.proof': 'Tested in competition, including at ARES.',
    'fw2.s4': 'The staff sets the targets. ORA produces and delivers.',
    'ct2.h1': '<span>Let’s talk about</span><span><em>your project.</em></span>',
    'ct2.s2': 'Order online. Pick up at your club.',
    'ct2.p2': 'Partner clubs become pickup points for ORA Drops: fewer individual deliveries, privileged access for their members.',
    'dr2.s1': 'Born in competition. Released as a Drop.',
    'dg.soon': 'Coming soon',
    'dg.h1': '<span>Fermented by ORA.</span><span><em>Finished by you.</em></span>',
    'dg.s1': 'The ORA dough ball: einkorn, wild sourdough, cold maturation. You choose the toppings.',
    'dg.cta': 'Get notified',
    'dg.k': 'Why Dough',
    'dg.n1': 'At home',
    'dg.w1': 'ORA’s fermentation craft, in your kitchen.',
    'dg.n2': 'Your toppings',
    'dg.w2': 'One base, every variation.',
    'dg.n3': 'Reorder',
    'dg.w3': 'Several dough balls, never the same pizza.',
    'nx.teams': 'How do we produce?',
    'nx.system': 'Tested in competition',
    'nx.fightweek': 'Let’s talk about your project',
    'nx.performance': 'The protocol',
    'nx.origin': 'Work with ORA',
    'nx.dough': 'See the Drop',
    'f.messagePh': 'Context, dates, delivery frequency…',
    'f.optSupply': 'Club supply',
    'f.optEvent': 'Event',
    'f.locationPh': 'City, country',
    'f.location': 'Location',
    'f.sportPh': 'MMA, football, cycling, endurance…',
    'f.sport': 'Sport',
    'f.org': 'Organisation',
    'ct2.l2': 'Drop 001 — early access',
    'nvl.dp': 'Coming soon · club pickup',
    'ct2.p2': 'Coming soon: partner clubs as pickup points for ORA Drops. The network is being built: your club can apply.',
    'dr2.pp': 'Drop 001 Reload is the first. Each edition will join this list after its release.',
    'dr2.kp': 'Past drops',
    'dr2.fa3': 'Coming soon. Club pickup (Drop Points) is not open yet: it will be announced here. Your club can already apply.',
    'dr2.fa7': 'Drop 001 Reload follows ARES 45 (20 November 2026, Adidas Arena — Paris), where ORA is official supplier: a format born in competition, then released to the public as a limited series.',
    'dr2.fq7': 'Where does Drop 001 come from?',
    'dr2.e2d': 'Each drop is produced in limited quantities, in batches.',
    'dr2.e2': 'Limited series',
    'dr2.lim': 'Limited release',
    'dr2.s1': 'Born in competition. Released as a drop.',
    'dr2.next': 'Next drop',
    'sy2.pp': 'Hitting the targets is not enough: the athlete has to want to eat. Real pizza, real pasta, so the planned portion actually gets eaten.',
    'sy2.hp': '<span>Palatability</span><span><em>is part of performance.</em></span>',
    'sy2.c4d': 'Taste is a criterion, not a bonus.',
    'sy2.c4': 'Palatability',
    'sy2.c3d': 'Each portion is calibrated to the staff’s target.',
    'sy2.c3': 'Portions',
    'sy2.c2d': 'pH is monitored throughout maturation.',
    'sy2.c2': 'pH monitoring',
    'sy2.c1d': 'Several days, cold. Time does the work.',
    'sy2.c1': 'Maturation',
    'sy2.hc': '<span>Controlled,</span><span><em>from sourdough to portion.</em></span>',
    'sy2.kc': 'Control',
    'nvl.workflow': 'Targets · Formulation · Production · Delivery',
    'tm2.ow3': 'Competitions, tournaments, organisations, activations, backstage.',
    'tm2.on3': 'Event',
    'tm2.ow2': 'Weekly deliveries, recurring production, adapted portions. The format evolves with the staff’s instructions.',
    'tm2.ow1': 'D-7 to D+1, in three phases: Before · Reload · Recover. Delivery coordinated with the staff.',
    'tm2.staff': 'ORA does not replace the nutritionist, dietitian, coach or chef. The staff decides, ORA delivers.',
    'tm2.w4': 'On the schedule of the club, the camp or the event.',
    'tm2.n4': 'Delivery',
    'tm2.w5': 'Calibrated portions, packed and labelled.',
    'tm2.n5': 'Portioning &amp; packaging',
    'tm2.w3': 'Einkorn, wild sourdough, cold maturation monitored by pH.',
    'tm2.n3': 'Production',
    'tm2.w2': 'ORA formulates the format around the targets. The staff approves.',
    'tm2.n2': 'Formulation',
    'tm2.w1': 'The staff sets the targets: carbohydrates, protein, fat, fibre, sodium, portions, constraints, frequency.',
    'tm2.n1': 'Targets',
    'tm2.s1': 'Your staff defines the needs. ORA formulates, produces, packs and delivers.',
    'cta.project': 'Work with ORA',
    'ares.case': 'First case study',
    'ares.m': '20 November 2026 · Adidas Arena — Paris',
    'ares.k': 'Official supplier — ARES 45',
    'hx.claim': '<span class="hx__l1">Your staff sets the targets.</span> <em>ORA builds and delivers the food.</em>',
    'hx.tag': '<span class="hx__long">Performance food supplier for clubs, teams &amp; athletes</span><span class="hx__short">Performance food for clubs &amp; athletes</span>',
    'tm2.hx': '<span>Produced.</span><span>Portioned.</span><span><em>Delivered.</em></span>',
    'cta.products': 'Our products',
    'pr3.c_p': 'Discover drops',
    'pr3.p_p': 'Limited editions born in the competition environment.',
    'pr3.s_p': 'Born in competition.<br>Released as a drop.',
    'pr3.c_c': 'Talk about your project',
    'pr3.p_c': 'Your staff defines the needs. ORA designs, produces and delivers the formats.',
    'pr3.s_c': 'Performance food supply for clubs,<br>teams &amp; organisations.',
    'pr3.c_d': 'Discover Dough',
    'pr3.p_d': 'ORA dough balls, ready to stretch and bake at home.',
    'pr3.s_d': 'Fermented by ORA.<br>Finished by you.',
    'pr3.s1': 'Performance food for clubs.<br>Products for everyone else.',
    'pr3.h1': '<span>What we</span><span><em>supply.</em></span>',
    'ey.products': 'Products',
    'nx.products': 'Work with ORA',
    'nv2.gProducts': 'Everything ORA supplies.',
    'nvl.drops': 'Born in competition, released as a drop',
    'nvc.products': 'Dough · Clubs · Dough Drops',
    'dr2.fa1': 'On 10 January 2027 at 10:00 (Paris time). Orders open automatically at that time, within the limit of the quantities produced. Join early access to be notified.',
    'dr3.w3': 'It is released to the public, for the time of a drop.',
    'dr3.n3': 'Release',
    'dr3.w2': 'It becomes a limited edition, produced in batches.',
    'dr3.n2': 'Edition',
    'dr3.w1': 'The format is designed for a competition environment, around the staff’s targets.',
    'dr3.n1': 'Competition',
    'dr3.k1': 'How a drop is born',
    'dr3.cta': 'The next drop',
    'dr3.p1': 'Limited pizza editions, born in the competition environment, released to the public for the time of a drop.',
    'dr3.h1': '<span>Pizza</span><span><em>Drops.</em></span>',
    'dr3.k0': 'Pizza Drops',
    'dg.note': '220 g dough balls · einkorn, wild sourdough, cold maturation · contains gluten. Temperature-controlled delivery.',
    'dg.last': 'Last units',
    'dg.soldout': 'Sold out',
    'dg.add': 'Add to cart',
    'dg.priceSoon': 'Price revealed soon',
    'dg.kSalt': 'Total salt',
    'dg.kFibre': 'Total fibre',
    'dg.kCarbs': 'Total carbs',
    'dg.kTot': 'Total dough',
    'dg.units': 'dough balls',
    'dg.hf': '<span>Choose</span><span><em>your format.</em></span>',
    'dg.kf': 'Formats',
    'dg.ctaF': 'See the formats',
    'dg.h1': '<span>Fermented by ORA.</span><span><em>Your move.</em></span>',
    'dr3.k1': 'Pizza Drops · How a drop is born',
    'dr4.s1': 'Einkorn, wild sourdough, cold maturation. You choose the toppings.',
    'dr4.k1': 'Drop Dough',
    'dr4.cta2': 'Next drop',
    'dr4.cta1': 'Order the dough',
    'dr4.p1': 'ORA dough balls, to finish at home. And limited pizza editions, born in competition.',
    'dr4.k0': 'Drop Dough · Pizza Drops',
    'nx.contact2': 'Let’s talk about your project',
    'tm3.kfw': 'Fight Week · The proof',
    'tm3.cs': 'Discover the System',
    'tm3.ss': 'Einkorn, wild sourdough, cold maturation, controlled macros: the system behind every format.',
    'tm3.hs': '<span>How</span><span><em>we produce.</em></span>',
    'dr5.s1': 'The competition dough, in a limited edition.',
    'dr3.w2': 'It becomes a limited-edition dough, produced in batches.',
    'dr3.w1': 'The recipe is designed for a competition environment, around the staff’s targets.',
    'dr3.k1': 'Dough Drops · How a drop is born',
    'dr4.p1': 'ORA dough balls, to finish at home. And limited-edition dough, born in competition.',
    'dr4.k0': 'Drop Dough · Dough Drops',
    'nvl.drops': 'Limited-edition dough',
    'pr3.p_p': 'Limited-edition dough: recipes and flours born in competition.',
    'pr3.s_d': 'Fermented by ORA.<br>Your move.',
    'tm3.ss': 'The system behind every format.',
    'ct2.p2': 'Partner clubs as pickup points for ORA Drops. The network is being built: your club can apply.',
    'dg.note': 'Contains gluten (einkorn). Temperature-controlled delivery.',
    'dr3.k0': 'Dough Drops',
    'dr4.p1': 'ORA dough, at home. Special editions, born in competition.',
    'dr4.s1': 'A champion’s dough. Your creativity.',
    'dg.rk': 'One dough ball',
    'dg.rW': 'Weight',
    'dg.rC': 'Carbs',
    'dg.rF': 'Fibre',
    'dg.rS': 'Salt',
    'dr2.fa5': 'Our dough is made with einkorn. It contains gluten, salt and water. The full allergen list is on each product page and on the label.',
    'tm2.ow1': 'Whether in preparation or recovery, we have the format your needs call for, whatever the sport. Delivery coordinated with the staff.',
    'tm2.ow2': 'Regular deliveries, recurring production, adapted portions. We can also produce on site, live, to fine-tune to the exact needs.',
    'sy2.p3': 'Several days, guided by pH.',
    'p2.p1': 'While sport swore only by protein,<br><span class="nw">ORA&nbsp;1929 puts carbohydrates back at the heart of performance.</span><br>Our dough — California champion and qualified for the World Championships — was born and developed in competition to meet athletes’ demands: efficiency, digestibility and flavour.',
    'sy2.pp': 'Performance is not only played out in the numbers. It is also played out in the desire to eat. ORA makes real pizza and real pasta so that every planned portion is actually eaten.',
    'nv2.gAbout': 'How ORA builds the food, and where ORA comes from.',
    'tm2.ow2': 'Regular deliveries, recurring production, adapted portions. We can also produce on site to fine-tune to the exact needs.',
    'dr4.p1': 'Our dough at home. Our most exclusive editions, born in competition.',
    'dr3.w1': 'Recipes designed for competition, around the staff’s targets.',
    'tm2.w2': 'ORA formulates the format around the targets.',
    'tm2.w3': 'Maturation monitored by pH.',
    'tm2.ow1': 'Whether in preparation or recovery, we have the format your needs call for, whatever the sport.',
    'tm2.ow2': 'We can also produce on site to fine-tune to your exact needs.',
    'nvt.products': 'Products',
    'nvl.workflow': 'Targets · Formulation · Delivery',
    'dr3.w1': 'A dough born for competition, built for performance.',
    'dr3.w1': 'Want to eat the same dough as your favourite athlete?',
    'cta.about': 'Who we are',
    'dr3.w1': 'What if you ate the same dough as your favourite athlete?',
    'dr3.w2': 'It becomes a limited-edition dough ball.',
    'f.send': 'Send',
    'dg.h1': '<span>ORA know-how.</span><span><em>Your finishing touch.</em></span>',
    'pr3.s_d': 'ORA know-how.<br>Your finishing touch.',
    'nvc.dough': 'ORA know-how. Your finishing touch.',
    'dr3.h': '<span>From the circuit</span><span><em>to your kitchen.</em></span>',
    'dr3.p': 'ORA dough balls for your pizzas, soon joined by our dried pasta.<br>Fresh pasta, however, stays exclusive to competition.',
    'dr6.n1': 'At home',
    'dr6.w1': 'ORA dough balls are available to make your pizzas at home, with your own toppings.',
    'dr6.n2': 'Coming soon',
    'dr6.w2': 'ORA dried pasta will also join the range, designed to bring the ORA world into your kitchen.',
    'dr6.n3': 'In competition',
    'dr6.w3': 'Fresh pasta remains an exclusive format, developed for athletes and competition settings.',
  };
  var TITLES_EN = {
    entry: 'ORA Performance Food | Clubs & Athletes',
    teams: 'Clubs & Organisations | ORA Performance',
    system: 'The ORA System | Fermentation, Einkorn & Performance',
    dough: 'ORA Dough | Fermented by ORA. Finished by You.',
    products: 'Products | ORA Performance',
    notfound: 'Page not found · ORA 1929',
    fightweek: 'Fight Week — Born in competition | ORA Performance',
    contact: 'Contact — Let’s talk about your project | ORA Performance',
    performance: 'The Science — Built for the reload | ORA Performance',
    origin: 'Origin — BORIS BERARD | ORA Performance',
    custom: 'Teams & Clubs | ORA Performance',
    legal: 'Legal notice & privacy · ORA 1929',
    cgv: 'Terms of sale · ORA 1929',
    drop: 'Drops | ORA Performance',
    ares: 'ORA Performance — Born in fight week',
    systeme: 'The ORA System | Einkorn, Sourdough & Maturation',
    science: 'Science · ORA Performance'
  };
  var FR_TITLE = document.title;

  /* ================= 2. DROP ENGINE ================= */
  var STATE = {
    fr: {
      coming_soon:  { label: 'Bientôt', line: function (d) { return 'Ouverture ' + d; }, cta: 'Accès anticipé', card: 'M’avertir', bar: 'Liste d’attente ouverte' },
      early_access: { label: 'Accès anticipé', line: function () { return 'Accès anticipé ouvert'; }, cta: 'S’inscrire', card: 'M’avertir', bar: 'Inscriptions ouvertes' },
      live:         { label: 'Drop live', line: function () { return 'Disponible maintenant'; }, cta: 'Précommander', card: 'Précommander', bar: 'Précommandes ouvertes' },
      ending:       { label: 'Dernières commandes', line: function () { return 'Ferme bientôt'; }, cta: 'Précommander', card: 'Précommander', bar: 'Dernières commandes' },
      closed:       { label: 'Fermé', line: function () { return 'Prochain drop bientôt'; }, cta: function (n) { return 'Rejoindre le Drop ' + n; }, card: 'Fermé', off: true, bar: 'Prochain drop bientôt' },
      sold_out:     { label: 'Épuisé', line: function (d, D) { return 'Drop ' + D.number + ' épuisé'; }, cta: function (n) { return 'Rejoindre le Drop ' + n; }, card: 'Épuisé', off: true, bar: 'Épuisé' }
    },
    en: {
      coming_soon:  { label: 'Coming soon', line: function (d) { return 'Coming ' + d; }, cta: 'Join early access', card: 'Notify me', bar: 'Waiting list open' },
      early_access: { label: 'Early access', line: function () { return 'Early access open'; }, cta: 'Sign up', card: 'Notify me', bar: 'Sign-ups open' },
      live:         { label: 'Drop live', line: function () { return 'Now available'; }, cta: 'Pre-order', card: 'Pre-order', bar: 'Pre-orders open' },
      ending:       { label: 'Last orders', line: function () { return 'Closing soon'; }, cta: 'Pre-order', card: 'Pre-order', bar: 'Last orders' },
      closed:       { label: 'Closed', line: function () { return 'Next drop coming soon'; }, cta: function (n) { return 'Join Drop ' + n; }, card: 'Closed', off: true, bar: 'Next drop coming soon' },
      sold_out:     { label: 'Sold out', line: function (d, D) { return 'Drop ' + D.number + ' sold out'; }, cta: function (n) { return 'Join Drop ' + n; }, card: 'Sold out', off: true, bar: 'Sold out' }
    }
  };
  var FORMAT = { fr: { pizza: 'Pizza', focaccia: 'Focaccia', pasta: 'Pâtes' }, en: { pizza: 'Pizza', focaccia: 'Focaccia', pasta: 'Pasta' } };
  var SPEC = {
    fr: { tba: 'À venir', priceTba: 'Voir les formats ↓', packUnits: 'Drop Reload', unit: 'unité', unitsLabel: 'unités Performance', unitLabel1: 'unité Performance', ship: 'Livraison incluse', packCta: 'Accès anticipé', packDetails: 'Détails', packDesc: 'Pâte d’exception & ingrédients premium sous température contrôlée.', packSoon: 'Prochainement', packJoin: 'Inscrivez-vous sur la liste d’attente pour accéder au Drop.', packUnitsK: 'Unités', packShipK: 'Livraison', packShipV: 'Incluse', priceSoon: 'Prix dévoilé le [date]', carbs: 'G glucides', protein: 'G protéines', kcal: 'kcal', dough: 'Pâte', c: 'Glucides', p: 'Protéines', e: 'Énergie', lot: 'Lot', foot: '14C Protocol<br>Contient du gluten (petit épeautre)<br>Valeurs finales à venir', waitOpen: 'Accès anticipé<br>Drop 001.', waitNext: 'Liste d’attente<br>Drop ' },
    en: { tba: 'TBA', priceTba: 'See the packs ↓', packUnits: 'Reload Drop', unit: 'unit', unitsLabel: 'Performance Units', unitLabel1: 'Performance Unit', ship: 'Delivery included', packCta: 'Join early access', packDetails: 'Details', packDesc: 'Exceptional dough & premium ingredients, temperature-controlled.', packSoon: 'Coming soon', packJoin: 'Join the waiting list to get access to the Drop.', packUnitsK: 'Units', packShipK: 'Delivery', packShipV: 'Included', priceSoon: 'Price revealed on [date]', carbs: 'G carbs', protein: 'G protein', kcal: 'kcal', dough: 'Dough', c: 'Carbs', p: 'Protein', e: 'Energy', lot: 'Lot', foot: '14C Protocol<br>Contains gluten (einkorn)<br>Final values to come', waitOpen: 'Drop 001<br>early access.', waitNext: 'Waiting list<br>Drop ' }
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function val(x) { return x == null || x === '' ? '—' : esc(x); }
  /* Spec value, or a discreet 'À venir' when the final value doesn't exist yet (never invent values) */
  function spec(x, unit) { return x == null || x === '' ? '<span class="tba">' + SPEC[LANG].tba + '</span>' : esc(x) + (unit ? ' ' + unit : ''); }
  function shortDate(iso) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || ''); return m ? m[3] + '.' + m[2] + '.' + m[1].slice(2) : ''; }
  function S(state) { var t = STATE[LANG]; return t[state] || t.coming_soon; }
  function txt(v) { return typeof v === 'function' ? v(DROP.next) : v; }
  function loc(v) { return v && typeof v === 'object' ? (v[LANG] || v.fr || '') : (v || ''); }
  function isBuyable(state) { return state === 'live' || state === 'ending'; }

  function ctaHref(el) {
    var base = el.getAttribute('data-base') || '';
    return isBuyable(DROP.state) && DROP.checkoutUrl ? DROP.checkoutUrl : base + '#acces';
  }

  /* Product sheet: optional mood crop (p.visual), name, specs, price, CTA */
  function cardHTML(p) {
    var st = p.status || DROP.state;
    var s = S(st);
    var L = SPEC[LANG];
    var fmt = FORMAT[LANG][p.format] || p.format;
    var price = p.price == null ? '<a class="tba" href="#formats">' + L.priceTba + '</a>' : esc(p.price);
    var href = isBuyable(st) && (p.url || DROP.checkoutUrl) ? (p.url || DROP.checkoutUrl) : '#acces';
    var off = s.off ? ' aria-disabled="true" tabindex="-1"' : '';
    var row = function (k, v) { return '<div><dt>' + k + '</dt><dd>' + v + '</dd></div>'; };
    var v = p.visual;
    var fig = v && v.src ? '<figure class="card__img' + (isBuyable(st) ? '' : ' card__img--soon') + '"><img src="' + esc(v.src) + '"' +
      (v.srcSmall ? ' srcset="' + esc(v.srcSmall) + ' ' + (v.wSmall || 700) + 'w, ' + esc(v.src) + ' ' + (v.w || 1200) + 'w" sizes="(max-width:640px) 100vw, 50vw"' : '') +
      ' width="' + (v.w || 1200) + '" height="' + (v.h || 900) + '" alt="' + esc(loc(v.alt)) + '" loading="lazy" decoding="async"' + (v.pos ? ' style="object-position:' + esc(v.pos) + '"' : '') + ' /></figure>' : '';
    return '<article class="card" data-format="' + esc(p.format) + '">' + fig +
      '<div class="card__head k"><span>Drop ' + esc(DROP.number) + ' · ' + esc(fmt) + '</span><span class="card__state">' + esc(s.label) + '</span></div>' +
      '<h3 class="d card__name">' + esc(p.name) + '</h3>' +
      (p.size ? '<p class="card__size k">' + esc(String(loc(p.size)).toUpperCase()) + '</p>' : '') +
      '<dl class="card__spec">' +
        row(p.doughLabel ? esc(loc(p.doughLabel)) : L.dough, spec(p.dough ? String(p.dough).toUpperCase() : null, '')) +
        row(L.c, spec(p.carbs, 'G')) + row(L.e, spec(p.kcal, 'KCAL')) + row(L.p, spec(p.protein, 'G')) +
      '</dl>' +
      (p.note ? '<p class="card__note">' + esc(loc(p.note)) + '</p>' : '') +
      '<div class="card__buy"><span class="card__price">' + price + '</span>' +
      '<a class="go" href="' + esc(href) + '" data-track="card_' + esc(p.id) + '"' + off + '>' + esc(txt(s.card)) + ' <i>→</i></a></div></article>';
  }

  /* Reload Drop packs (DROP.packs): price + computed price per unit, delivery included */
  function money(n) {
    var s = (Math.round(n * 100) / 100).toFixed(2);
    if (/\.00$/.test(s)) s = s.slice(0, -3);
    return LANG === 'fr' ? s.replace('.', ',') + ' €' : '€' + s;
  }
  /* Drop page: ProductRevealCard behaviour (image, card lifts, details slide up on hover / focus).
     No price, rating, heart, discount or cart: prices follow showPrices, CTA = early access. */
  /* Shopify theme only: window.ORA_SHOP (printed by the page.drop template from real products / inventory).
     Absent on the static site → the cards below behave exactly as before. */
  function shopPhase(S) {
    var st = S.status || 'auto', now = Date.now();
    if (st === 'closed') return st;
    if (window.ORA_EARLY_OK && window.ORA_EARLY_OK()) return 'open';  /* early access link (Shopify) */
    if (st === 'coming_soon') return st;
    if (st === 'open') return 'open';
    var a = S.startAt ? Date.parse(S.startAt) : NaN, b = S.endAt ? Date.parse(S.endAt) : NaN;
    if (!isNaN(a) && now < a) return 'coming_soon';
    if (!isNaN(b) && now >= b) return 'closed';
    return 'open';
  }
  var SHOP_TXT = {
    fr: { AVAILABLE: 'Disponible', 'LOW STOCK': 'Stock limité', 'FINAL UNITS': 'Dernières unités', 'SOLD OUT': 'Épuisé', 'COMING SOON': 'Bientôt', 'DROP CLOSED': 'Drop fermé', order: 'Commander', left: function (n) { return n + (n > 1 ? ' unités restantes' : ' unité restante'); } },
    en: { AVAILABLE: 'Available', 'LOW STOCK': 'Low stock', 'FINAL UNITS': 'Final units', 'SOLD OUT': 'Sold out', 'COMING SOON': 'Coming soon', 'DROP CLOSED': 'Drop closed', order: 'Order', left: function (n) { return n + (n > 1 ? ' units left' : ' unit left'); } }
  };
  function shopPack(k) {
    var S = window.ORA_SHOP;
    if (!S || !S.packs || !S.packs[k.id]) return null;
    var sp = S.packs[k.id], phase = shopPhase(S), T = SHOP_TXT[LANG], key, cta;
    if (phase === 'coming_soon') key = 'COMING SOON';
    else if (phase === 'closed') key = 'DROP CLOSED';
    else if (!sp.available) key = 'SOLD OUT';
    else key = T[sp.label] ? sp.label : 'AVAILABLE';
    var state = T[key];
    var buy = phase === 'open' && sp.available && sp.variant;
    if (buy) cta = '<a class="pk__cta" href="/cart/' + esc(String(sp.variant)) + ':1" data-shop-cta="' + esc(k.id) + '">' + esc(T.order) + ' <i>→</i></a>';
    else cta = '<span class="pk__cta is-off" aria-disabled="true">' + esc(state) + '</span>';
    /* the exact count only while it can still be bought (never "0 left" on a sold-out pack) */
    return { phase: phase, state: state, units: buy && sp.unitsLeft != null ? T.left(sp.unitsLeft) : null, price: sp.price, was: sp.compareAt && sp.compareAt > sp.price ? sp.compareAt : null, cta: cta };
  }

  /* card copy: "Drop 001 — Prochainement" / kit line / "Accès prioritaire sur inscription." (first and last only while it cannot be bought) */
  function cardTxt(L) {
    var T = (DROP.cardText && DROP.cardText[LANG]) || {};
    var ps = (T.priceSoon || L.priceSoon).replace('[date]', shortDate(DROP.opensAt));
    return { soon: T.soon || L.packSoon, desc: T.desc || L.packDesc, join: T.join || L.packJoin, priceSoon: ps };
  }
  function packText(k, L) {
    var soon = !isBuyable(DROP.state), C = cardTxt(L), d = (k.desc && loc(k.desc)) || C.desc;
    return (soon ? '<strong class="pk__soon">' + esc(DROP.number ? 'Drop ' + DROP.number + ' — ' : '') + esc(C.soon) + '</strong><br>' : '') + esc(d) +
      (soon && C.join ? '<span class="pk__join">' + esc(C.join) + '</span>' : '');
  }

  function packRevealHTML(k) {
    var L = SPEC[LANG], img = k.image || {}, sh = shopPack(k);
    /* price mode (Shopify: Theme settings > ORA Drop > Affichage des prix): open = hidden until the Drop opens, hidden = never, always */
    var pm = DROP.priceMode || 'open', live = sh && sh.phase !== 'coming_soon';
    var price = (sh && sh.price != null && (pm === 'always' || (pm === 'open' && live)))
      ? '<p class="pk__price num">' + (sh.was ? '<s class="pk__was">' + money(sh.was / 100) + '</s> ' : '') + money(sh.price / 100) +
        (sh.was ? ' <span class="pk__off">−' + Math.round((1 - sh.price / sh.was) * 100) + ' %</span>' : '') +
        (k.units ? ' <span class="k">' + money(sh.price / 100 / k.units) + ' / ' + esc(L.unit) + '</span>' : '') + '</p>'
      : (pm === 'hidden' && live) ? ''
      : (DROP.showPrices === false || pm === 'hidden' || k.price == null) ? '<p class="k pk__price pk__price--soon">' + esc(cardTxt(L).priceSoon) + '</p>'
      : '<p class="pk__price num">' + money(k.price) + ' <span class="k">' + money(k.price / k.units) + ' / ' + esc(L.unit) + '</span></p>';
    if (sh) price += '<p class="k pk__state">' + esc(sh.state) + (sh.units ? ' · ' + esc(sh.units) : '') + '</p>';
    return '<article class="pk' + (k.badge ? ' pk--flag' : '') + '">' +
      (img.logo ? packVisualHTML(k) : img.src ? '<figure class="pk__img pk__img--shot"><img src="' + esc(img.src) + '"' + (img.srcSmall ? ' srcset="' + esc(img.srcSmall) + ' 700w, ' + esc(img.src) + ' 1200w" sizes="(max-width:760px) 60vw, (max-width:1099px) 42vw, 25vw"' : '') + ' alt="' + esc(img.alt ? loc(img.alt) : 'ORA 1929 — ' + k.name) + '" width="1200" height="900" loading="lazy" decoding="async"' + (img.pos ? ' style="object-position:' + esc(img.pos) + '"' : '') + ' /></figure>' : '') +
      '<div class="pk__body">' +
        '<div class="pack__head k"><span>' + esc(L.packUnits) + '</span>' + (k.badge ? '<span class="pack__badge">' + esc(loc(k.badge)) + '</span>' : '') + '</div>' +
        '<h3 class="d pk__name">' + esc(k.name) + '</h3>' +
        '<p class="k pk__units">' + k.units + ' ' + esc(k.units === 1 ? L.unitLabel1 : L.unitsLabel) + '</p>' + price +
      '</div>' +
      '<div class="pk__overlay"><div class="pk__in">' +
        '<p class="k pk__k">' + esc(L.packDetails) + '</p>' +
        '<p class="pk__desc">' + packText(k, L) + '</p>' +
        '<dl class="pk__feat"><div><dt class="k">' + esc(L.packUnitsK) + '</dt><dd>' + k.units + '</dd></div><div><dt class="k">' + esc(L.packShipK) + '</dt><dd>' + esc(L.packShipV) + '</dd></div></dl>' +
        (sh ? sh.cta : '<a class="pk__cta" href="#acces" data-track="pack_' + esc(k.id) + '">' + esc(L.packCta) + ' <i>→</i></a>') +
      '</div></div>' +
    '</article>';
  }
  function packHTML(k, cta) {
    var L = SPEC[LANG];
    return '<article class="pack' + (k.badge ? ' pack--flag' : '') + '">' +
      '<div class="pack__head k"><span>' + esc(L.packUnits) + '</span>' + (k.badge ? '<span class="pack__badge">' + esc(loc(k.badge)) + '</span>' : '') + '</div>' +
      '<h3 class="d pack__name">' + esc(k.name) + '</h3>' +
      '<p class="k pack__units">' + k.units + ' ' + esc(k.units === 1 ? L.unitLabel1 : L.unitsLabel) + '</p>' +
      '<p class="pack__who">' + (k.who ? esc(loc(k.who)) : '&nbsp;') + '</p>' +
      (DROP.showPrices === false ? '<p class="k pack__soon">' + esc(L.priceSoon) + '</p>' :
        '<p class="d pack__price num">' + money(k.price) + '</p>' +
        '<p class="k pack__unit num">' + money(k.price / k.units) + ' / ' + esc(L.unit) + '</p>') +
      '<p class="k mute pack__ship">' + esc(L.ship) + '</p>' +
      (cta ? '<a class="tl pack__cta" href="#acces" data-track="pack_' + esc(k.id) + '">' + esc(L.packCta) + ' <i>→</i></a>' : '') +
    '</article>';
  }

  var countdownTimer = null;
  function renderDrop() {
    if (!DROP) return;
    var s = S(DROP.state);
    var date = shortDate(DROP.opensAt);
    var line = s.line(date, DROP);
    if (DROP.early) line = LANG === 'en' ? 'Early access · open for you' : 'Accès anticipé · ouvert pour vous';
    var head = 'Drop ' + DROP.number + ' · ' + DROP.name;

    document.querySelectorAll('[data-bar]').forEach(function (bar) {
      var items = [head, line, s.bar];
      var once = items.map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('');
      var twice = items.map(function (t) { return '<span aria-hidden="true">' + esc(t) + '</span>'; }).join('');
      bar.innerHTML = once + twice;
    });
    document.querySelectorAll('[data-drop-chip]').forEach(function (el) { el.textContent = s.label; el.setAttribute('data-state', DROP.state); });
    document.querySelectorAll('[data-drop-line]').forEach(function (el) { el.textContent = line; });
    document.querySelectorAll('[data-drop-number]').forEach(function (el) { el.textContent = DROP.number; });
    document.querySelectorAll('[data-drop-name]').forEach(function (el) { el.textContent = DROP.name; });
    document.querySelectorAll('[data-drop-cta]').forEach(function (el) {
      var span = el.querySelector('span') || el;
      var force = DROP.cta && el.hasAttribute('data-drop-hero-cta') ? DROP.cta : null;
      span.textContent = force && force[LANG] ? force[LANG] : txt(s.cta);
      el.setAttribute('href', force && force.url ? force.url : ctaHref(el));
    });

    /* Homepage hero (Drop panel) — copy + product image from drop-config.js */
    document.querySelectorAll('[data-drop-head]').forEach(function (el) { el.textContent = head; });
    document.querySelectorAll('[data-drop-headline]').forEach(function (el) { el.textContent = loc(DROP.headline); });
    document.querySelectorAll('[data-drop-desc]').forEach(function (el) { el.textContent = loc(DROP.description); });
    document.querySelectorAll('[data-drop-hero-figure]').forEach(function (fig) {
      var im = DROP.image, img = fig.querySelector('img');
      fig.hidden = !im || !im.src;
      if (fig.hidden) return;
      if (!img) {
        img = document.createElement('img');
        img.setAttribute('sizes', '(max-width:720px) 86vw, 44vw');
        img.setAttribute('decoding', 'async');
        fig.appendChild(img);
      }
      if (img.getAttribute('src') !== im.src) {
        img.setAttribute('src', im.src);
        img.setAttribute('width', im.width || 1100);
        img.setAttribute('height', im.height || 1100);
        if (im.srcMobile) img.setAttribute('srcset', im.srcMobile + ' ' + (im.widthMobile || 640) + 'w, ' + im.src + ' ' + (im.width || 1100) + 'w');
        else img.removeAttribute('srcset');
      }
      img.setAttribute('alt', loc(im.alt) || head);
    });
    document.querySelectorAll('[data-drop-sticky]').forEach(function (el) { el.textContent = 'Drop ' + DROP.number + ' · ' + s.label; });
    document.querySelectorAll('[data-drop-waitlist-title]').forEach(function (el) {
      var L = SPEC[LANG];
      el.innerHTML = (DROP.state === 'closed' || DROP.state === 'sold_out') ? L.waitNext + esc(DROP.next) + '.' : L.waitOpen;
    });
    document.querySelectorAll('[data-drop-packs]').forEach(function (el) { var cta = el.hasAttribute('data-pack-cta'), rv = el.hasAttribute('data-pack-reveal'); el.innerHTML = (DROP.packs || []).map(function (k) { return rv ? packRevealHTML(k) : packHTML(k, cta); }).join(''); });
    var grid = document.querySelector('[data-drop-grid]');
    if (grid) {
      grid.innerHTML = DROP.products.map(cardHTML).join('');
      applyFilter(currentFilter);
    }

    var cd = document.querySelector('[data-drop-countdown]');
    if (cd) {
      if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
      var target = NaN, kind = '';
      if ((DROP.state === 'coming_soon' || DROP.state === 'early_access') && DROP.opensAtISO) { target = Date.parse(DROP.opensAtISO); kind = 'open'; }
      else if (DROP.state === 'ending' && DROP.closesAt) { target = Date.parse(DROP.closesAt); kind = 'close'; }
      if (target > Date.now()) {
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var lab = kind === 'open' ? (LANG === 'en' ? 'Opens in' : 'Ouverture dans') : (LANG === 'en' ? 'Closes in' : 'Fermeture dans');
        var tick = function () {
          var ms = Math.max(0, target - Date.now()), sec = Math.floor(ms / 1000);
          var d = Math.floor(sec / 86400), h = Math.floor(sec % 86400 / 3600), m = Math.floor(sec % 3600 / 60), x = sec % 60;
          cd.innerHTML = '<em>' + lab + '</em>' + (d ? '<span>' + pad(d) + '</span><small>' + (LANG === 'en' ? 'D' : 'J') + '</small>' : '') +
            '<span>' + pad(h) + '</span><small>H</small><span>' + pad(m) + '</span><small>M</small><span>' + pad(x) + '</span><small>S</small>';
          if (ms <= 0) {
            clearInterval(countdownTimer); countdownTimer = null;
            /* Shopify: the theme recomputes the state from the dates, so a reload opens / closes the Drop by itself */
            if (window.ORA_SHOP && !window.__oraFlip) { window.__oraFlip = true; setTimeout(function () { location.reload(); }, 1500); }
          }
        };
        tick(); countdownTimer = setInterval(tick, 1000); cd.hidden = false;
      } else { cd.hidden = true; }
    }
    /* early-access form only while you cannot buy (coming soon, closed, sold out) */
    document.querySelectorAll('[data-drop-waitlist]').forEach(function (el) { el.hidden = isBuyable(DROP.state); });
  }

  var currentFilter = 'all';
  function applyFilter(f) {
    currentFilter = f;
    document.querySelectorAll('[data-filters] button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-filter') === f)); });
    document.querySelectorAll('[data-drop-grid] .card').forEach(function (c) { c.hidden = f !== 'all' && c.getAttribute('data-format') !== f; });
  }
  function bindFilters() {
    document.querySelectorAll('[data-filters] button').forEach(function (b) {
      b.addEventListener('click', function () { applyFilter(b.getAttribute('data-filter')); track('drop_filter', { filter: b.getAttribute('data-filter') }); });
    });
  }

  function bindSticky() {
    var bar = document.querySelector('[data-sticky]');
    var hero = document.querySelector('[data-drop-hero]');
    var form = document.getElementById('acces');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var heroIn = true, formIn = false;
    var upd = function () {
      var on = !heroIn && !formIn;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      bar.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
    };
    new IntersectionObserver(function (e) { heroIn = e[0].isIntersecting; upd(); }).observe(hero);
    if (form) new IntersectionObserver(function (e) { formIn = e[0].isIntersecting; upd(); }).observe(form);
  }

  /* ================= LANGUAGE ================= */
  function getLang() {
    var l = null;
    try { l = localStorage.getItem('ora-lang'); } catch (e) {}
    return l === 'en' ? 'en' : 'fr';
  }
  function swapAttr(sel, attr, store) {
    document.querySelectorAll('[' + sel + ']').forEach(function (el) {
      if (el.dataset[store] === undefined) el.dataset[store] = el.getAttribute(attr) || '';
      var k = el.getAttribute(sel);
      el.setAttribute(attr, (LANG === 'en' && EN[k] != null) ? EN[k].replace(/<[^>]+>/g, '') : el.dataset[store]);
    });
  }
  function applyLang(lang) {
    if (window.ORA_EN) Object.keys(window.ORA_EN).forEach(function (k) { if (window.ORA_EN[k]) EN[k] = window.ORA_EN[k]; });  /* Shopify: EN texts edited in Customize */
    LANG = lang === 'en' ? 'en' : 'fr';
    try { localStorage.setItem('ora-lang', LANG); } catch (e) {}
    document.documentElement.lang = LANG;
    document.querySelectorAll('[data-pi]').forEach(function (el) {
      if (el.dataset.piFr === undefined) el.dataset.piFr = el.innerHTML;
      var k = el.getAttribute('data-pi');
      el.innerHTML = (LANG === 'en' && EN[k] != null) ? EN[k] : el.dataset.piFr;
    });
    swapAttr('data-pi-ph', 'placeholder', 'piFrPh');
    swapAttr('data-pi-aria', 'aria-label', 'piFrAria');
    swapAttr('data-pi-alt', 'alt', 'piFrAlt');
    document.querySelectorAll('[data-lang-block]').forEach(function (b) { b.hidden = b.getAttribute('data-lang-block') !== LANG; });
    document.querySelectorAll('.lang button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-lang') === LANG)); });
    document.title = (LANG === 'en' && TITLES_EN[PAGE]) ? TITLES_EN[PAGE] : FR_TITLE;
    renderDrop();
    headlinesCase();
    markAccents();
    if (PAGE === 'legal') legalAnchor();
  }
  /* Rhode-style headlines: natural sentence case (no shouting caps). EN slogans written in Title Case
     in the HTML are displayed as sentences; acronyms (ORA, 14C, 001…) and brand words stay as written. */
  var KEEP = { 'ORA': 1, 'Drop': 1, 'Reload': 1, 'System': 1, 'Boris': 1, 'Berard': 1, 'Pizza': 0 };
  function sentenceCase(el) {
    var start = true, walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      node.textContent = node.textContent.replace(/[A-Za-zÀ-ÖØ-öø-ÿŒœ0-9][\wÀ-ÖØ-öø-ÿŒœ-]*|[.!?]/g, function (w) {
        if (/^[.!?]$/.test(w)) { start = true; return w; }
        var out = w;
        var isAcr = w.length > 1 && w === w.toUpperCase() && /[A-Z]/.test(w);
        if (!isAcr && !KEEP[w] && !/\d/.test(w)) out = start ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w.toLowerCase();
        start = false;
        return out;
      });
    });
  }
  function headlinesCase() {
    document.querySelectorAll('.d').forEach(function (el) {
      if (el.closest('.sig, .card, .pk, .pack, .label, .label__drop, .c14, .chain, .ph__menu, .flow, .ed-sci__t, .ms-tile, .ms-list, .pkv')) return;
      sentenceCase(el);
    });
  }
  /* Anton accents (É, Ê, À, Û…) rise ~1.11em and Ç drops ~0.31em: any condensed title holding one
     gets the .acc class (extra line-height) so stacked lines never touch, in FR and EN */
  function markAccents() {
    var re = /[À-ÖØ-Ýà-öø-ýŒœ]/;
    document.querySelectorAll('.d, .label__name, .specs dt, .ed-facts dd, .pv-fieldset legend, .pv-success h3, .legal h2').forEach(function (el) {
      el.classList.toggle('acc', re.test(el.textContent));
    });
  }
  function legalAnchor() {
    var h = (location.hash || '').slice(1);
    if (!h) return;
    var map = LANG === 'en' ? { confidentialite: 'privacy', mentions: 'legal-notice' } : { privacy: 'confidentialite', 'legal-notice': 'mentions' };
    var t = document.getElementById(map[h] || h);
    if (t && t.offsetParent !== null) setTimeout(function () { t.scrollIntoView(); }, 60);
  }

  /* ================= 3. ATTRIBUTION + TRACKING ================= */
  var ATTR = {};
  function initAttribution() {
    var q = new URLSearchParams(location.search);
    var store = null, saved = null;
    try { store = window.sessionStorage; } catch (e) {}
    try { saved = store ? JSON.parse(store.getItem('ora-attr') || 'null') : null; } catch (e) {}
    var pageEvent = BODY.getAttribute('data-source-event') || '';
    var campaign = UTM.some(function (k) { return q.get(k); }) || q.get('source_event') || (pageEvent && !(saved && saved.source_event));
    if (campaign || !saved) {
      var ref = document.referrer && document.referrer.indexOf(location.host) === -1 ? document.referrer : '';
      var a = { landing_page: location.pathname, referrer: ref.slice(0, 300) };
      UTM.forEach(function (k) { var v = q.get(k); if (v) a[k] = v.slice(0, 120); });
      var se = q.get('source_event') || pageEvent || '';
      if (!se && /ares/i.test((a.utm_source || '') + ' ' + (a.utm_campaign || ''))) se = 'ARES45';
      if (se) a.source_event = se.toUpperCase().replace(/[^A-Z0-9_-]/g, '').slice(0, 40);
      if (!campaign && saved) a = saved;
      saved = a;
      try { if (store) store.setItem('ora-attr', JSON.stringify(saved)); } catch (e) {}
    }
    ATTR = saved || {};
    var aud = (q.get('audience') || '').replace(/[^a-z]/gi, '');
    if (aud) { var pick = document.querySelector('[data-audience="' + aud + '"]'); if (pick) pick.classList.add('is-suggested'); }
  }

  function loadPlausible() {
    if (!CFG.plausible.enabled) return;
    window.plausible = window.plausible || function () { (window.plausible.q = window.plausible.q || []).push(arguments); };
    window.plausible.init = window.plausible.init || function (i) { window.plausible.o = i || {}; };
    window.plausible.init();
    var s = document.createElement('script'); s.async = true; s.src = CFG.plausible.src; document.head.appendChild(s);
  }

  function track(name, props, cb) {
    var data = {};
    Object.keys(props || {}).forEach(function (k) { data[k] = props[k]; });
    if (ATTR.source_event) data.source_event = ATTR.source_event;
    data.lang = LANG;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data));
    /* Shopify: every event also goes to customer-events pixels (Meta, Google, TikTok… set in Settings > Customer events) */
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish('ora_' + name, data); } catch (e) {}
    if (typeof window.plausible === 'function') window.plausible(name, cb ? { props: data, callback: cb } : { props: data });
    else if (cb) cb();
  }

  /* Shopify theme only: view_drop on the Drop page, select_drop + begin_checkout on "Order Drop"
     (purchase is tracked by a Shopify customer-events pixel on the thank-you page). */
  function bindShop() {
    if (!window.ORA_SHOP) return;
    track('view_drop', {});
    document.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target.closest('[data-shop-cta]') : null;
      if (!el || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      var href = el.getAttribute('href'), pack = el.getAttribute('data-shop-cta'), done = false;
      /* campaign attribution travels with the order (cart permalink attributes → Order > Additional details) */
      try { var u = new URL(href, location.origin); ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'source_event', 'landing_page'].forEach(function (k) { if (ATTR[k]) u.searchParams.set('attributes[' + k + ']', ATTR[k]); }); href = u.pathname + u.search; } catch (e) {}
      var go = function () { if (!done) { done = true; window.location.href = href; } };
      track('select_drop', { pack: pack });
      track('begin_checkout', { pack: pack }, go);
      setTimeout(go, 600);
    });
  }

  function bindClicks() {
    document.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target.closest('[data-track]') : null;
      if (!el) return;
      track('cta_click', { cta: el.getAttribute('data-track') });
      var ares = el.getAttribute('data-ares');
      if (!ares || ATTR.source_event !== 'ARES45') return;
      var href = el.getAttribute('href') || '';
      var leaves = href && href.charAt(0) !== '#' && !e.metaKey && !e.ctrlKey && !e.shiftKey && el.target !== '_blank';
      if (leaves) {
        e.preventDefault();
        var done = false, go = function () { if (!done) { done = true; window.location.href = href; } };
        track(ares, {}, go); setTimeout(go, 350);
      } else { track(ares, {}); }
    });
  }

  function pageViews() {
    var map = { entry: 'entry_view', performance: 'performance_view', custom: 'custom_view', drop: 'drop_view', ares: 'ares_view', systeme: 'system_view', science: 'science_view' };
    if (map[PAGE]) track(map[PAGE], {});
    var dp = document.getElementById('drop-point');
    if (dp && 'IntersectionObserver' in window) {
      var seen = false, io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting && !seen) { seen = true; track('drop_point_view', {}); io.disconnect(); }
      }, { threshold: 0.3 });
      io.observe(dp);
    }
  }

  /* ================= 4. FORMS ================= */
  var MSG = {
    fr: { required: 'Ce champ est obligatoire.', email: 'Adresse e-mail invalide.', number: 'Merci d’indiquer un nombre valide.',
      consent: 'Merci de cocher cette case pour vous inscrire.', tooLong: 'Ce texte est trop long.', sending: 'Envoi en cours…',
      fix: 'Merci de vérifier les champs indiqués.', rate: 'Trop de tentatives. Merci de réessayer dans un moment.',
      error: 'L’envoi n’a pas abouti. Réessayez, ou écrivez-nous à <a href="mailto:info@ora1929.com">info@ora1929.com</a>.',
      ok: { custom: ['C’est dans le pétrin ! 🍕', 'Ton message est bien reçu. On laisse reposer un instant et on revient vers toi avant la fin du temps de pousse !'],
            consumer_drop: ['Vous êtes sur la liste.', 'Nous vous écrirons à l’ouverture du prochain Drop.'],
            drop_point: ['C’est dans le pétrin ! 🍕', 'Ton message est bien reçu. On laisse reposer un instant et on revient vers toi avant la fin du temps de pousse !'] } },
    en: { required: 'This field is required.', email: 'Please enter a valid email address.', number: 'Please enter a valid number.',
      consent: 'Please tick this box to join the list.', tooLong: 'This text is too long.', sending: 'Sending…',
      fix: 'Please check the highlighted fields.', rate: 'Too many attempts. Please try again in a moment.',
      error: 'Something went wrong. Please try again, or email us at <a href="mailto:info@ora1929.com">info@ora1929.com</a>.',
      ok: { custom: ['It’s in the dough! 🍕', 'Your message is in. We’ll let it rest for a moment and get back to you before the proofing time is up!'],
            consumer_drop: ['You’re on the list.', 'We’ll email you when the next Drop opens.'],
            drop_point: ['It’s in the dough! 🍕', 'Your message is in. We’ll let it rest for a moment and get back to you before the proofing time is up!'] } }
  };
  var SUCCESS_EVENT = { custom: 'custom_lead', consumer_drop: 'drop_waitlist_signup', drop_point: 'drop_point_lead' };

  function fieldError(el) {
    var M = MSG[LANG], box = el.type === 'checkbox';
    var v = box ? el.checked : (el.value || '').trim();
    if (el.required && !v) return box ? M.consent : M.required;
    if (!v || box) return '';
    if (el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return M.email;
    if (el.type === 'number' && (!/^\d+$/.test(v) || +v < 1 || +v > 999)) return M.number;
    if (el.maxLength > 0 && v.length > el.maxLength) return M.tooLong;
    return '';
  }
  function showError(el, msg) {
    var err = el.id ? document.getElementById(el.id + '-err') : null;
    if (msg) {
      el.setAttribute('aria-invalid', 'true');
      if (err) { err.textContent = msg; var d = (el.getAttribute('aria-describedby') || '').replace(err.id, '').trim(); el.setAttribute('aria-describedby', (d + ' ' + err.id).trim()); }
    } else { el.removeAttribute('aria-invalid'); if (err) err.textContent = ''; }
  }
  function bindForm(form) {
    var type = form.getAttribute('data-lead'), readyAt = Date.now(), started = false, submitted = false;
    var fields = Array.prototype.slice.call(form.querySelectorAll('input:not([type=hidden]):not([name=website]), select, textarea'));
    var btn = form.querySelector('button[type=submit]'), status = form.querySelector('.pv-status');
    var start = function () { if (!started) { started = true; track('form_start', { form: type }); } };
    form.addEventListener('input', start); form.addEventListener('change', start);
    fields.forEach(function (el) {
      el.addEventListener(el.type === 'checkbox' || el.tagName === 'SELECT' ? 'change' : 'input', function () { if (submitted) showError(el, fieldError(el)); });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault(); submitted = true;
      var M = MSG[LANG], first = null;
      fields.forEach(function (el) { var m = fieldError(el); showError(el, m); if (m && !first) first = el; });
      if (first) { status.textContent = M.fix; first.focus(); return; }
      var fd = new FormData(form);
      fd.set('lead_type', type); fd.set('lang', LANG); fd.set('page', location.pathname); fd.set('_elapsed', String(Date.now() - readyAt));
      ['landing_page', 'referrer', 'source_event'].concat(UTM).forEach(function (k) { if (ATTR[k]) fd.set(k, ATTR[k]); });
      btn.disabled = true; status.textContent = M.sending;
      fetch(CFG.endpoint, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }).then(function (j) { j._status = r.status; return j; }); })
        .then(function (res) {
          if (res && res.ok) {
            track(SUCCESS_EVENT[type], { form: type });
            var ok = MSG[LANG].ok[type], card = form.parentNode;
            card.innerHTML = '<div class="pv-success" role="status" tabindex="-1"><h3></h3><p></p></div>';
            card.querySelector('h3').textContent = ok[0]; card.querySelector('p').textContent = ok[1];
            card.querySelector('.pv-success').focus();
            return;
          }
          if (res && res.errors) {
            var bad = null;
            Object.keys(res.errors).forEach(function (n) {
              var el = form.querySelector('[name="' + n + '"]'); if (!el) return;
              var c = res.errors[n];
              showError(el, c === 'email' ? M.email : c === 'consent' ? M.consent : c === 'number' ? M.number : c === 'too_long' ? M.tooLong : M.required);
              if (!bad) bad = el;
            });
            status.textContent = M.fix; if (bad) bad.focus();
          } else if (res && res._status === 429) { status.textContent = M.rate; }
          else { status.innerHTML = M.error; }
          btn.disabled = false;
        })
        .catch(function () { status.innerHTML = MSG[LANG].error; btn.disabled = false; });
    });
  }

  /* ================= 5. REVEAL ================= */
  function bindReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
    var failsafe = function () { els.forEach(function (e) { if (e.getBoundingClientRect().top < innerHeight * 1.1) e.classList.add('is-in'); }); };
    window.addEventListener('load', failsafe); setTimeout(failsafe, 1200);
  }

  /* ================= 7. MOTION (vanilla, no library) =================
     Scroll-linked effects follow the normal page scroll — nothing is ever pinned or blocked.
     - [data-xs]          hero (home), ContainerScroll behaviour: title rises, framed box goes from tilted to frontal
     - [data-expand]      image opens from a soft crop to full frame (Palatabilité, /custom/)
     - [data-progress]    5-step chain fills as it scrolls through (Le déroulé, /custom/)
     - [data-parallax]    photo drifts slowly inside its frame (protocol chapters, /systeme/)
     - [data-stagger]     children appear one after another (spec label lines)
     - [data-sc]          Pizza / Pasta showcase switch (home)
     prefers-reduced-motion: everything is shown in its final state. */
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function bindMotion() {
    var items = [];
    document.querySelectorAll('[data-xs]').forEach(function (sec) {
      var card = sec.querySelector('[data-xs-card]');
      if (card) items.push({ type: 'xs', el: sec, card: card, head: sec.querySelector('[data-xs-head]'), cur: 0 });
    });
    document.querySelectorAll('[data-expand]').forEach(function (el) { items.push({ type: 'expand', el: el, strong: el.getAttribute('data-expand') === 'strong', cur: 0 }); });
    document.querySelectorAll('[data-parallax]').forEach(function (el) { items.push({ type: 'parallax', el: el, cur: 0 }); });
    document.querySelectorAll('[data-progress]').forEach(function (el) {
      items.push({ type: 'progress', el: el, steps: el.querySelectorAll('li'), cur: 0 });
    });
    /* TextReveal "fade-in-blur", per word: every strong title of the site (h1/h2 and big statements) */
    document.querySelectorAll('main h1.d, main h2.d, main p.d.d-l, main p.d.d-xl, main p.d.d-xxl, body.entry .entry__title').forEach(function (el) {
      if (!el.closest('.label, .pv-formcard') && !el.matches('.ares__title, .entry__title')) el.setAttribute('data-words', '');  /* entry: no word reveal on the old title */
    });
    /* [data-words]: a title revealed word by word (light, once) */
    document.querySelectorAll('[data-words]').forEach(function (el) {
      var n = 0, walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var frag = document.createDocumentFragment();
        node.textContent.split(/([ \t\n\r]+)/).forEach(function (part) {
          if (!part) return;
          if (/^[ \t\n\r]+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          var w = document.createElement('span'); w.className = 'w'; w.style.setProperty('--wi', n++); w.textContent = part; frag.appendChild(w);
        });
        node.parentNode.replaceChild(frag, node);
      });
      el.setAttribute('data-stagger', '');
    });
    document.querySelectorAll('[data-stagger]').forEach(function (el, n) {
      Array.prototype.forEach.call(el.querySelectorAll('[data-stagger-item]'), function (c, i) { c.style.setProperty('--i', i); });
    });
    if (REDUCED) {
      items.forEach(function (it) { apply(it, 1); });
      document.querySelectorAll('[data-stagger]').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -12% 0px' });
      document.querySelectorAll('[data-stagger]').forEach(function (el) { io.observe(el); });
    } else document.querySelectorAll('[data-stagger]').forEach(function (el) { el.classList.add('is-in'); });
    if (!items.length) return;

    function target(it) {
      var vh = window.innerHeight, r = it.el.getBoundingClientRect();
      if (it.type === 'xs') return clamp01(-r.top / Math.max(1, r.height - vh * 0.9));
      if (it.type === 'expand') return it.strong ? clamp01((vh * 0.72 - r.top) / (vh * 0.6)) : clamp01((vh - r.top) / (vh * 0.9));
      if (it.type === 'progress') return clamp01((vh * 0.8 - r.top) / (r.height + vh * 0.25));
      if (it.type === 'parallax') return clamp01((vh - r.top) / (vh + r.height));
      return 1;
    }
    function apply(it, p) {
      var mobile = window.innerWidth <= 768;
      if (it.type === 'xs') {
        /* ContainerScroll: rotateX 20 → 0, scale 1.05 → 1 (phone 0.7 → 0.9, softer tilt), title rises 100px */
        var rot = (mobile ? 12 : 20) * (1 - p), sc = mobile ? 0.7 + 0.2 * p : 1.05 - 0.05 * p;
        it.card.style.transform = 'rotateX(' + rot.toFixed(2) + 'deg) scale(' + sc.toFixed(4) + ')';
        if (it.head) it.head.style.transform = 'translateY(' + (-100 * p).toFixed(1) + 'px)';
      } else if (it.type === 'expand') {
        var k = it.strong ? (mobile ? 1.2 : 1.3) : 1; /* polish v21: the box starts larger, the opening is quieter */
        var ix = (mobile ? 4 : 9) * k * (1 - p), iy = (mobile ? 3 : 7) * k * (1 - p), rad = 14 * (1 - p);
        it.el.style.setProperty('--ex', p.toFixed(4));
        it.el.style.setProperty('--clip', 'inset(' + iy.toFixed(2) + '% ' + ix.toFixed(2) + '% round ' + rad.toFixed(1) + 'px)');
        it.el.style.setProperty('--zoom', (1.08 - 0.08 * p).toFixed(4));
      } else if (it.type === 'parallax') {
        /* slow drift of the photo inside its frame: ±6% desktop, ±2% phone */
        it.el.style.setProperty('--py', (((p - 0.5) * 2) * (mobile ? 2 : 6)).toFixed(3) + '%');
      } else if (it.type === 'progress') {
        it.el.style.setProperty('--p', p.toFixed(4));
        var n = it.steps.length;
        Array.prototype.forEach.call(it.steps, function (li, i) { li.classList.toggle('is-on', p >= (i + 0.35) / n); });
      }
    }
    var ticking = false;
    function frame() {
      var moving = false;
      items.forEach(function (it) {
        var t = target(it);
        it.cur += (t - it.cur) * 0.12;               /* slow, eased follow of the scroll */
        if (Math.abs(t - it.cur) > 0.0008) moving = true; else it.cur = t;
        apply(it, it.cur);
      });
      ticking = moving;
      if (moving) requestAnimationFrame(frame);
    }
    function kick() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    items.forEach(function (it) { it.cur = target(it); apply(it, it.cur); });
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
  }

  /* Pizza / Pasta showcase: tabs (click + arrow keys), crossfade of text and image */
  /* ================= HEADER + FULL-SCREEN MENU =================
     Discreet fixed header (Drop · Performance · Teams · Menu). It gets a solid black ground after a few px of scroll.
     "Menu" opens a full-screen chapter index (01–07): focus is kept inside, Esc / Fermer close it, page scroll is locked. */
  function bindHeader() {
    var oh = document.querySelector('[data-oh]');
    if (!oh) return;
    var ticking = false;
    function update() { oh.classList.toggle('is-scrolled', window.scrollY > 8); ticking = false; }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    /* category dropdowns: hover/focus open them on desktop (CSS); the caret toggles them for touch and keyboard */
    var dds = Array.prototype.slice.call(oh.querySelectorAll('[data-dd]'));
    function closeDd(except) {
      dds.forEach(function (d) { if (d !== except) { d.classList.remove('is-open'); var c = d.querySelector('.oh__caret'); if (c) c.setAttribute('aria-expanded', 'false'); } });
    }
    dds.forEach(function (d) {
      var c = d.querySelector('.oh__caret');
      if (c) c.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !d.classList.contains('is-open');
        closeDd(d); d.classList.toggle('is-open', open); c.setAttribute('aria-expanded', String(open));
        if (open) track('nav_dropdown', { category: d.querySelector('.oh__top').textContent });
      });
      d.addEventListener('mouseenter', function () { closeDd(d); });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-dd]')) closeDd(null); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = dds.filter(function (d) { return d.classList.contains('is-open') || d.contains(document.activeElement); })[0];
      if (open) { closeDd(null); var t = open.querySelector('.oh__top'); if (t) { t.focus(); t.blur(); } }
    });
    var om = document.querySelector('[data-om]'), btn = oh.querySelector('[data-om-open]');
    if (!om || !btn) return;
    var back = null, timer = 0;
    function focusables() { return Array.prototype.filter.call(om.querySelectorAll('a[href], button'), function (el) { return el.offsetParent !== null; }); }
    function set(open) {
      clearTimeout(timer);
      btn.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('om-lock', open);
      if (open) {
        back = document.activeElement;
        om.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          om.classList.add('is-open');
          var first = om.querySelector('.om__list a');
          if (first) first.focus({ preventScroll: true });
        }); });
        track('menu_open', {});
      } else {
        om.classList.remove('is-open');
        timer = setTimeout(function () { om.hidden = true; }, REDUCED ? 0 : 460);
        if (back && back.focus) back.focus({ preventScroll: true });
      }
    }
    btn.addEventListener('click', function () { set(true); });
    om.querySelectorAll('[data-om-close]').forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    om.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    document.addEventListener('keydown', function (e) {
      if (om.hidden) return;
      if (e.key === 'Escape') { set(false); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  /* ================= FORM SHEETS (mobile) =================
     On phones the long forms are not on the page: a button opens them full screen (like a product sheet).
     Links to #contact / #acces / #drop-point open the matching sheet too. Desktop: forms stay inline. */
  function bindSheets() {
    var mq = window.matchMedia('(max-width:760px)'), open = null, back = null;
    function show(sh) {
      if (!sh || !mq.matches) return false;
      back = document.activeElement; open = sh;
      /* lift the sheet out of its section (sections create stacking contexts) so it covers the header too */
      sh.__home = { parent: sh.parentNode, next: sh.nextSibling }; document.body.appendChild(sh);
      sh.classList.add('is-open'); document.documentElement.classList.add('om-lock');
      var f = sh.querySelector('input, select, textarea'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 350);
      track('form_sheet_open', { id: sh.id });
      return true;
    }
    function hide() {
      if (!open) return;
      open.classList.remove('is-open'); document.documentElement.classList.remove('om-lock');
      if (open.__home) open.__home.parent.insertBefore(open, open.__home.next);
      open = null;
      if (back && back.focus) back.focus({ preventScroll: true });
    }
    function sheetFor(hash) {
      var t = hash && hash.length > 1 ? document.getElementById(hash.slice(1)) : null;
      if (!t) return null;
      return t.matches('[data-sheet]') ? t : t.querySelector('[data-sheet]');
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sheet-open]');
      if (b) { show(document.getElementById(b.getAttribute('data-sheet-open'))); return; }
      if (e.target.closest('[data-sheet-close]')) { hide(); return; }
      var a = e.target.closest('a[href*="#"]');
      if (!a || !mq.matches) return;
      var u = new URL(a.href, location.href);
      if (u.pathname !== location.pathname) return;
      var sh = sheetFor(u.hash);
      if (sh) { e.preventDefault(); show(sh); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    if (mq.matches) { var sh = sheetFor(location.hash); if (sh) show(sh); }
  }

  /* ================= INFINITE SLIDER (press logos) =================
     Vanilla port of motion-primitives "InfiniteSlider": the logo set is repeated until it is wider than the
     band, then doubled, and the track loops by exactly one set. Hovering slows it down smoothly
     (data-hover-speed); paused off screen; static (wrapped) with reduced motion. Speeds are in px/s. */
  function bindSlider() {
    document.querySelectorAll('[data-slider]').forEach(function (box) {
      var track = box.firstElementChild;
      if (!track || REDUCED) return;
      var base = Array.prototype.slice.call(track.children), speed = +box.getAttribute('data-speed') || 40,
          slow = +box.getAttribute('data-hover-speed') || speed, cur = speed, target = speed, x = 0, setW = 0, last = 0, on = true, raf = 0;
      function build() {
        while (track.children.length > base.length) track.removeChild(track.lastChild);
        var reps = 1;
        while (track.scrollWidth < box.clientWidth * 1.2 && reps < 12) {
          base.forEach(function (n) { var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.alt = ''; track.appendChild(c); });
          reps++;
        }
        var n = track.children.length;
        for (var i = 0; i < n; i++) { var c = track.children[i].cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.alt = ''; track.appendChild(c); }
        setW = track.children[n].offsetLeft - track.children[0].offsetLeft;
        x = x % setW;
      }
      function frame(t) {
        raf = 0;
        if (!on) return;
        var dt = last ? Math.min(.05, (t - last) / 1000) : 0; last = t;
        cur += (target - cur) * Math.min(1, dt * 4);
        x -= cur * dt;
        if (setW && x <= -setW) x += setW;
        track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
        raf = requestAnimationFrame(frame);
      }
      function start() { if (!raf) { last = 0; raf = requestAnimationFrame(frame); } }
      box.addEventListener('mouseenter', function () { target = slow; });
      box.addEventListener('mouseleave', function () { target = speed; });
      var rt = 0;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 200); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { on = e[0].isIntersecting; if (on) start(); }).observe(box);
      Promise.all(base.map(function (im) { return im.complete ? 0 : new Promise(function (r) { im.addEventListener('load', r); im.addEventListener('error', r); }); })).then(function () { build(); start(); });
      base.forEach(function (im) { im.loading = 'eager'; });
    });
  }

  /* ================= PACK VISUAL (Drop) =================
     IntegrationCard, ported: the ORA mark in the centre, one node per Performance Unit,
     linked by fine lines where a gold pulse travels (SVG + CSS, no library). */
  function packVisualHTML(k) {
    var n = Math.max(1, Math.min(16, k.units || 4)), W = 564, H = 352, cx = W / 2, cy = H / 2;
    var nodes = [], paths = '', boxes = '';
    for (var i = 0; i < n; i++) {
      var a = -Math.PI / 2 + (i + .5) * 2 * Math.PI / n;
      nodes.push({ x: cx + Math.cos(a) * 214, y: cy + Math.sin(a) * 128 });
    }
    nodes.forEach(function (p, i) {
      var sx = cx + (p.x < cx ? -18 : 18), dir = p.y < cy ? -1 : 1, r = 14, d;
      if (Math.abs(p.y - cy) < 20) d = 'M ' + sx + ' ' + cy + ' H ' + p.x.toFixed(1) + (Math.abs(p.y - cy) > .5 ? ' V ' + p.y.toFixed(1) : '');
      else d = 'M ' + sx + ' ' + cy + ' V ' + (p.y - dir * r).toFixed(1) + ' Q ' + sx + ' ' + p.y.toFixed(1) + ' ' + (sx + (p.x < sx ? -r : r)) + ' ' + p.y.toFixed(1) + ' H ' + p.x.toFixed(1);
      var delay = ((i * 0.37) % 2).toFixed(2);
      paths += '<path class="pkv__line" d="' + d + '"/><path class="pkv__pulse" d="' + d + '" style="animation-delay:-' + delay + 's"/>';
      boxes += '<g class="pkv__node" style="--d:' + (0.06 * i).toFixed(2) + 's"><rect x="' + (p.x - 15).toFixed(1) + '" y="' + (p.y - 15).toFixed(1) + '" width="30" height="30" rx="8"/>' +
        '<circle cx="' + p.x.toFixed(1) + '" cy="' + p.y.toFixed(1) + '" r="3.2"/></g>';
    });
    var base = window.ORA_ASSET_BASE || '/img/';
    return '<figure class="pk__img pkv" aria-hidden="true">' +
      '<svg class="pkv__svg" viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="xMidYMid meet">' + paths + boxes + '</svg>' +
      '<span class="pkv__core"><img src="' + esc(base + 'logo-ora1929-440.webp') + '" alt="" width="440" height="125" loading="lazy" decoding="async" /><i></i></span>' +
      '<span class="pkv__n k">' + n + (LANG === 'en' ? (n === 1 ? ' unit' : ' units') : (n === 1 ? ' unité' : ' unités')) + '</span>' +
    '</figure>';
  }

  /* ================= INIT ================= */
  function init() {
    initAttribution();
    applyLang(getLang());
    document.querySelectorAll('.lang button').forEach(function (b) { b.addEventListener('click', function () { applyLang(b.getAttribute('data-lang')); }); });
    bindFilters();
    bindSticky();
    loadPlausible();
    bindClicks();
    bindShop();
    pageViews();
    document.querySelectorAll('form[data-lead]').forEach(bindForm);
    document.querySelectorAll('[data-year]').forEach(function (y) { y.textContent = new Date().getFullYear(); });
    bindHeader();
    bindSlider();
    bindSheets();
    bindReveal();
    bindMotion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
/* ORA — video loops: load when near the screen, small file on phones, never with reduced motion / data saver */
(function () {
  var vids = document.querySelectorAll('video.cs__vid[data-vsrc]');
  if (!vids.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var save = navigator.connection && navigator.connection.saveData;
  if (reduce || save) { vids.forEach(function (v) { v.remove(); }); return; }
  var load = function (v) {
    if (v.src) return;
    var sm = v.getAttribute('data-vsrc-sm');
    v.src = (sm && window.innerWidth < 761) ? sm : v.getAttribute('data-vsrc');
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  };
  /* position check on load / scroll / resize: play what is on screen (±200 px), pause the rest */
  var ticking = false;
  var check = function () {
    ticking = false;
    var h = window.innerHeight || document.documentElement.clientHeight;
    vids.forEach(function (v) {
      var r = v.getBoundingClientRect();
      if (r.bottom > -200 && r.top < h + 200) {
        load(v);
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (v.src && !v.paused) { v.pause(); }
    });
  };
  var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame ? requestAnimationFrame(check) : setTimeout(check, 50); } };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  check();
  window.addEventListener('load', check);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) check(); });
})();

/* ORA motion+ (2026-10-16): gold spotlight on step cards (desktop pointer) + 01 → 05 counter on the method */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.cs__steps > li').forEach(function (li) {
      li.addEventListener('pointermove', function (e) {
        var r = li.getBoundingClientRect();
        li.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        li.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }
  var lists = document.querySelectorAll('[data-count]');
  if (!lists.length || reduce) return;
  var run = function (ol) {
    if (ol.__done) return; ol.__done = true;
    ol.querySelectorAll('b[data-n]').forEach(function (b, i) {
      var end = parseInt(b.getAttribute('data-n'), 10), n = 0;
      b.textContent = '00';
      setTimeout(function () {
        var t = setInterval(function () {
          n += 1; b.textContent = (n < 10 ? '0' : '') + n;
          if (n >= end) { clearInterval(t); b.classList.add('is-set'); }
        }, 90);
      }, 180 + i * 160);
    });
  };
  var check = function () {
    var h = window.innerHeight;
    lists.forEach(function (ol) { var r = ol.getBoundingClientRect(); if (r.top < h * 0.85 && r.bottom > 0) run(ol); });
  };
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('load', check);
  check();
})();
